import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";

// Flattened iteratively on purpose: a self-referencing component trips the
// dev-only visual-edits babel plugin (infinite prop tracing).
function flatten(categories, expanded) {
  const out = [];
  const stack = [...(categories || [])].reverse().map((n) => ({ node: n, depth: 0 }));
  while (stack.length) {
    const { node, depth } = stack.pop();
    out.push({ node, depth });
    if (expanded.includes(node.path) && node.children?.length) {
      for (let i = node.children.length - 1; i >= 0; i--) {
        stack.push({ node: node.children[i], depth: depth + 1 });
      }
    }
  }
  return out;
}

export default function CategoryTree({ categories, selected, onSelect }) {
  const [expanded, setExpanded] = useState([]);
  const rows = flatten(categories, expanded);

  const toggle = (path) =>
    setExpanded((e) => (e.includes(path) ? e.filter((p) => p !== path) : [...e, path]));

  return (
    <div className="max-h-72 overflow-auto pr-1" data-testid="category-tree">
      {rows.map(({ node, depth }) => {
        const active = selected === node.path;
        const hasKids = node.children?.length > 0;
        const open = expanded.includes(node.path);
        return (
          <div
            key={node.path}
            className={`flex items-center gap-1 rounded px-1 py-[3px] cursor-pointer text-[11px] ${
              active ? "bg-[#007BFF]/10 text-[#007BFF] font-medium" : "text-slate-600 hover:bg-slate-100"
            }`}
            style={{ paddingLeft: 4 + depth * 10 }}
            onClick={() => onSelect(active ? "" : node.path)}
            data-testid={`cat-node-${node.path}`}
          >
            {hasKids ? (
              <button
                onClick={(e) => { e.stopPropagation(); toggle(node.path); }}
                className="text-slate-400 hover:text-slate-700"
                data-testid={`cat-toggle-${node.path}`}
              >
                {open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
              </button>
            ) : <span className="w-3" />}
            <span className="truncate flex-1" title={node.name}>{node.name}</span>
            <span className="text-slate-400 tabular-nums">{node.count.toLocaleString()}</span>
          </div>
        );
      })}
    </div>
  );
}
